module.exports = __webpack_public_path__ + "img/paper-icn.69b04767.svg";